export default {
  contrats_pending: false,
  contrats: [],
  contrats_refresh_pending: false,
  lastModified: null
}
